module.exports = __webpack_public_path__ + "ebe5ee187eed5465407de6100ef87238.svg";